<template>

    <Report heading="Стоков оборот" resource="/stock-turnover" ref="report">

        <template v-slot:body="props">

        <table v-if="props.data.items">
            <thead>
                <tr>
                    <th colspan="2">Артикул</th>
                    <th colspan="2">Начално салдо</th>
                    <th colspan="2">Доставено</th>
                    <th colspan="2">Продадено</th>
                    <th colspan="2">Изписано</th>
                    <th colspan="2">Крайно салдо</th>
                </tr>
                <tr>
                    <th>Номер</th>
                    <th>Наименование</th>
                    <th>Количество</th>
                    <th>Стойност</th>
                    <th>Количество</th>
                    <th>Стойност</th>
                    <th>Количество</th>
                    <th>Стойност</th>
                    <th>Количество</th>
                    <th>Стойност</th>
                    <th>Количество</th>
                    <th>Стойност</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in props.data.items" :key="item">
                    <td class="number">{{item.number}}</td>
                    <td>{{item.name}}</td>
                    <td class="right number">{{item.begin.quantity}}</td>
                    <td class="right number">{{$utils.currency(item.begin.amount)}}</td>
                    <td class="right number">{{item.delivered.quantity}}</td>
                    <td class="right number">{{$utils.currency(item.delivered.amount)}}</td>
                    <td class="right number">{{item.sold.quantity}}</td>
                    <td class="right number">{{$utils.currency(item.sold.amount)}}</td>
                    <td class="right number">{{item.consumed.quantity}}</td>
                    <td class="right number">{{$utils.currency(item.consumed.amount)}}</td>
                    <td class="right number">{{item.end.quantity}}</td>
                    <td class="right number">{{$utils.currency(item.end.amount)}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="2" class="right">Общо:</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.begin.amount)}}</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.delivered.amount)}}</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.sold.amount)}}</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.consumed.amount)}}</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.end.amount)}}</th>
                </tr>
            </tfoot>
        </table>
        <br/>&nbsp;

        </template>
    </Report>

</template>

<script>

export default {
    data() {
        return {
        }
    },

    methods: {
    },

    computed: {
    }

}

</script>

<style>

</style>
